var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5391 1.17831C10.1486 0.787786 9.51545 0.787786 9.12493 1.17831L8.30344 1.9998L10.4987 4.19506L11.3202 3.37357C11.7107 2.98305 11.7107 2.34988 11.3202 1.95936L10.5391 1.17831ZM11.7916 3.84498C12.4425 3.1941 12.4425 2.13883 11.7916 1.48795L11.0105 0.706905C10.3597 0.0560315 9.30439 0.0560315 8.65352 0.706905L7.59662 1.7638C7.59652 1.7639 7.59643 1.764 7.59633 1.7641C7.59623 1.76419 7.59613 1.76429 7.59604 1.76439L0.929662 8.43076C0.86715 8.49327 0.832031 8.57806 0.832031 8.66647L0.832031 11.3331C0.832031 11.5172 0.98127 11.6665 1.16536 11.6665H3.83203C3.92044 11.6665 4.00522 11.6313 4.06773 11.5688L11.7916 3.84498ZM10.0273 4.66647L7.83203 2.4712L1.4987 8.80454L1.4987 10.9998H3.69396L10.0273 4.66647Z",
    fill: "#163567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4f11f7231edcb2d89bc9be8803e1b6bf.svg";
export { ForwardRef as ReactComponent };